import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Container, Row, Col, Button } from 'reactstrap';
import { Link } from "react-router-dom";
import LoadingImage from "../../../comum/components/LoadingImage";
import ModalAviso from "../../../comum/components/ModalAviso";
import ModalForm from "../../../comum/components/ModalForm";
import { IconeEditar, IconeCopiar, IconeProibido, IconeCarregar, Visualizar } from "../../../comum/components/Icones";
import Footer from "../../../comum/components/Footer";
import FooterContent from "../../../comum/components/FooterContent";
import { buscaFiltrarVazio, buscaSemResultado } from "../../../../utils/mensagens";
import CardAgendamentoNotaFiscal from "./CardAgendamentoNotaFiscal";

@inject("store")
@observer
export class TabelaAgendamentoNotaFiscal extends Component {

    constructor(props) {
        super(props);
        this.controller = this.props.controller;
        this.loginStore = this.props.store.loginStore;

        this.addAcoesCol();
    }

    can = (operacao = "C", tarefa = "NotasFiscaisAde") => this.loginStore.can(tarefa, operacao)

    addAcoesCol() {
        this.controller.colunas.push({
            dataField: 'acoes',
            isDummyField: true,
            text: '',
            formatter: (cell, row) => {
                return <Col className={"text-right"}>
                    {this.can("A") &&
                        (["P"].indexOf(row.Status) > -1) &&
                        <Link to={{ pathname: `/agendamento-nota-fiscal/editar/${row.NotaFiscalTranspId}`, editar: true }}>
                            <IconeEditar title={"Editar"} tamanho="lg" className="m-2" onClick={() => { }} />
                        </Link>
                    }
                    {this.can("C") &&
                        (["P"].indexOf(row.Status) < 0) &&
                        <Link to={{ pathname: `/agendamento-nota-fiscal/editar/${row.NotaFiscalTranspId}`, editar: true }}>
                            <Visualizar title={"Visualizar"} tamanho="lg" className="m-2" onClick={() => { }} />
                        </Link>
                    }
                    {this.can("I") &&
                        <Link to={{ pathname: "/agendamento-nota-fiscal/cadastro", notaFiscalSel: row, duplicar: true }}>
                            <IconeCopiar title={"Duplicar"} tamanho="lg" className="m-2" onClick={() => { }} />
                        </Link>
                    }
                    {this.can("E") &&
                        (["P"].indexOf(row.Status) > -1) &&
                        <a onClick={() => this.controller.setIdRow(row.NotaFiscalTranspId)} >
                            <IconeProibido title={"Excluir"} tamanho="lg" className="m-2" />
                        </a>
                    }
                </Col>
            },
            cardFormatter: (cell, row) => {
                return <Row>
                    <Col sm={12}>
                        {this.can("A") &&
                            (["P"].indexOf(row.Status) > -1) &&
                            <Link to={{ pathname: `/agendamento-nota-fiscal/editar/${row.NotaFiscalTranspId}`, editar: true }}>
                                <Button className="btn-com-bordas-editar">Editar</Button>
                            </Link>
                        }
                        {this.can("C") &&
                            (["P"].indexOf(row.Status) < 0) &&
                            <Link to={{ pathname: `/agendamento-nota-fiscal/editar/${row.NotaFiscalTranspId}`, editar: true }}>
                                <Button className="btn-com-bordas-editar">Visualizar</Button>
                            </Link>
                        }
                        {this.can("I") &&
                            <Link to={{ pathname: "/agendamento-nota-fiscal/cadastro", notaFiscalSel: row, duplicar: true }}>
                                <Button className="btn-com-bordas-cinza">Duplicar</Button>
                            </Link>
                        }
                        {this.can("E") &&
                            (["P"].indexOf(row.Status) > -1) &&
                            <Button className="btn-com-bordas-cancelar" onClick={() => this.controller.setIdRow(row.NotaFiscalTranspId)}>Excluir</Button>
                        }
                    </Col>
                </Row>
            }
        });
    }

    confirmAcao() {
        if (this.controller.modalConfirm) {
            if (this.controller.responseAcao) {
                return (
                    <ModalAviso onClickFechar={() => this.controller.setModalConfirm()}>
                        <h2>{this.controller.responseAcao}</h2>
                    </ModalAviso>
                )
            } else {
                return (
                    <ModalForm salvando={this.controller.excluindoNotas}
                        labelCancelar="NÃO"
                        labelConfirmar="SIM"
                        onClickCancelar={() => this.controller.setModalConfirm()}
                        onClickSalvar={() => this.controller.cancelarNota(this.controller.idRowSelecionada)}>
                        <h2>Confirma o cancelamento?</h2>
                    </ModalForm>
                )
            }
        }
    }

    render() {
        let lista = this.controller.notasFiscaisLista.length > 0 ? this.controller.notasFiscaisLista : [];
        let loading = this.controller.loading;

        return (
            <Container fluid className="tabela-container">
                {(!this.controller.filtrado) ?
                    <Row>
                        <Col className="mt-3" xs={12}>
                            <span className="mensagem-filtrar">
                                {buscaFiltrarVazio}
                            </span>
                        </Col>
                    </Row>
                    :
                    <ToolkitProvider
                        keyField="NotaFiscalTranspId"
                        data={lista.slice()}
                        columns={[...this.controller.colunas]}
                    >
                        {props => (
                            <div>
                                {window.innerWidth > 991 ?

                                    <BootstrapTable bootstrap4
                                        striped
                                        bordered={false}
                                        noDataIndication={() => loading ?
                                            <LoadingImage /> : this.controller.tableMessage}
                                        classes="tabela agendamento"
                                        pagination={paginationFactory()}
                                        {...props.baseProps}
                                    />
                                    :
                                    <Row>
                                        {loading ?
                                            <LoadingImage />
                                            :
                                            (lista.length > 0 ?
                                                lista.map((card, x) => (
                                                    <CardAgendamentoNotaFiscal
                                                        key={x}
                                                        data={card}
                                                        id={x}
                                                        colunas={[...this.controller.colunas]}
                                                        cancelAction={this.controller.setIdRow}
                                                    />
                                                ))
                                                :
                                                <Col xs={12}>
                                                    <span className="mensagem-filtrar">
                                                        {buscaSemResultado}
                                                    </span>
                                                </Col>
                                            )
                                        }
                                    </Row>
                                }
                            </div>)
                        }
                    </ToolkitProvider>
                }

                <Footer>
                    <FooterContent>
                        {this.controller.total !== null && <div className="justify-content-between">
                            <div><b>{this.controller.loading ? <IconeCarregar tamanho="1x" className='mr-1' cor="#001C43" /> : this.controller.total}</b> Registros no Total - <a
                                onClick={() => this.controller.carregarLista()}>Atualizar Lista</a>
                            </div>
                            {this.controller.modalConfirm && this.confirmAcao()}
                        </div>}

                    </FooterContent>

                </Footer>

            </Container>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/agendamento/nota-fiscal-visualizar/components/TabelaAgendamentoNotaFiscal.js